"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AdminSettingsHomeQuery () {
        return AdminSettingsHomeQuery;
    },
    get PatchBrandingRequest () {
        return PatchBrandingRequest;
    },
    get PatchFunctionsRequest () {
        return PatchFunctionsRequest;
    },
    get PatchSettingsRequest () {
        return PatchSettingsRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const AdminSettingsHomeQuery = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId.optional()
});
const HexColor = _zod.z.string().trim().regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, "Color must be a #RGB or #RRGGBB hex code");
const RgbColor = _zod.z.string().trim().regex(/^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/, "Color must be an rgb() value with integer channels").refine((value)=>{
    const match = value.match(/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/);
    if (!match) return false;
    return match.slice(1).every((channel)=>{
        const n = Number(channel);
        return Number.isInteger(n) && n >= 0 && n <= 255;
    });
}, {
    message: "rgb() channels must each be an integer between 0 and 255"
});
const NamedColor = _zod.z.string().trim().toLowerCase().pipe(_zod.z.enum(_models.LEGACY_NAMED_COLORS));
const HexOrRgbColor = _zod.z.union([
    HexColor,
    RgbColor,
    NamedColor
]);
const PatchBrandingRequest = _zod.z.object({
    navColor: HexOrRgbColor.optional(),
    iconColor: HexOrRgbColor.optional(),
    preferredNavigation: _zod.z.enum(_models.COMPANY_PREFERRED_NAVIGATION_VALUES).optional()
}).refine((body)=>body.navColor !== undefined || body.iconColor !== undefined || body.preferredNavigation !== undefined, {
    message: "At least one of navColor, iconColor, or preferredNavigation must be provided",
    path: [
        "navColor"
    ]
});
const CompanyFunctionKeyEnum = _zod.z.enum(_models.COMPANY_FUNCTION_KEYS);
const CompanyFunctionValueEnum = _zod.z.enum(_models.COMPANY_FUNCTION_VALUES);
const PatchFunctionsRequest = _zod.z.object({
    updates: _zod.z.array(_zod.z.object({
        key: CompanyFunctionKeyEnum,
        value: CompanyFunctionValueEnum
    })).min(1, "At least one update is required")
});
const CompanyHomeBooleanSettingKeyEnum = _zod.z.enum(_models.COMPANY_HOME_BOOLEAN_SETTING_KEYS);
const ScalarSettingUpdate = _zod.z.union([
    _zod.z.object({
        key: _zod.z.literal("defaultTimezone"),
        value: _zod.z.string()
    }),
    _zod.z.object({
        key: _zod.z.literal("defaultReviewStartTime"),
        value: _zod.z.number().int()
    }),
    _zod.z.object({
        key: _zod.z.literal("defaultReviewCycleDueTime"),
        value: _zod.z.number().int()
    }),
    _zod.z.object({
        key: _zod.z.literal("decimalPlaces"),
        value: _zod.z.number().int()
    })
]);
const PatchSettingsRequest = _zod.z.object({
    updates: _zod.z.array(_zod.z.union([
        _zod.z.object({
            key: CompanyHomeBooleanSettingKeyEnum,
            value: _zod.z.boolean()
        }),
        ScalarSettingUpdate
    ])).min(1, "At least one update is required")
});
